import React, { useEffect, useRef, useState } from "react";
import { Button } from "./Button";
import { motion } from "framer-motion";
import { TypeAnimation } from "react-type-animation";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import * as THREE from "three";
import GLOBE from "vanta/dist/vanta.globe.min";
import "./HeroSection.css";

const HeroSection = () => {
  const [vantaEffect, setVantaEffect] = useState(null);
  const vantaRef = useRef(null);

  useEffect(() => {
    if (!vantaEffect) {
      setVantaEffect(
        GLOBE({
          el: vantaRef.current,
          THREE,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.0,
          minWidth: 200.0,
          scale: 1.0,
          scaleMobile: 1.0,
          color: 0x3b82f6,
          backgroundColor: 0x000000,
        })
      );
    }
    return () => {
      if (vantaEffect) vantaEffect.destroy();
    };
  }, [vantaEffect]);

  return (
    <div className="hero-section-wrapper" ref={vantaRef}>
      {/* 🌐 Social Icons */}
      <div className="hero-section-social-bar">
        <a href="https://github.com/piyushagarwalplay" target="_blank" rel="noreferrer">
          <FaGithub />
        </a>
        <a href="https://www.linkedin.com/in/piyush-agarwal-85b0301ba/" target="_blank" rel="noreferrer">
          <FaLinkedin />
        </a>
        <a href="https://www.instagram.com/piyushagarwal34/" target="_blank" rel="noreferrer">
          <FaInstagram />
        </a>
      </div>

      {/* 🧠 Text Content */}
      <div className="hero-section-content">
        <motion.h1
          className="hero-section-title"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          PIYUSH AGARWAL
        </motion.h1>

        <TypeAnimation
          sequence={[
            "I'm a Front-end Developer",
            1500,
            "I specialize in UI/UX Design",
            1500,
            "Currently learning Back-end Development",
            1500,
            "Based in Jaipur, India",
            2000,
          ]}
          wrapper="span"
          speed={50}
          repeat={Infinity}
          className="hero-section-intro"
        />

        <motion.div
          className="hero-section-btns"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 1 }}
        >
          <Button
            className="btns"
            buttonStyle="btn--outline"
            buttonSize="btn--large"
          >
            HIRE ME
          </Button>

          <a href="resume/Piyush_Agarwal.pdf" download>
            <button className="btn btn--primary hero-section-download-btn">
              DOWNLOAD RESUME
            </button>
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default HeroSection;
